import { useEffect, useRef } from "react";
import { device } from "web_myplann/Utils/device";

export const useDashboardStatusBarColor = (color: string | undefined) => {
	const colorRef = useRef(color);
	colorRef.current = color;

	useEffect(() => {
		if (color === undefined && document.visibilityState === "hidden") {
			return;
		}
		device.changeDashboardColor(color ?? "").catch(() => {});
	}, [color]);

	useEffect(() => {
		const restore = () => {
			if (document.visibilityState === "visible") {
				device.changeDashboardColor(colorRef.current ?? "").catch(() => {});
			}
		};
		document.addEventListener("visibilitychange", restore);
		window.addEventListener("pageshow", restore);

		return () => {
			device.changeDashboardColor("").catch(() => {});
			document.removeEventListener("visibilitychange", restore);
			window.removeEventListener("pageshow", restore);
		};
	}, []);
};
